import { createContext, useContext, useEffect, useState } from "react";

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [id, setId] = useState("");
  const [customParams, setCustomParams] = useState({});
  const [areFiltersAvailable, setAreFiltersAvailable] = useState(true);
  const [resultsLayoutMode, setResultsLayoutMode] = useState("grid");

  const { requestCustomParams, sortOptions, search, show_sandbox_input } =
    window.bn_config_search_page;

  const {
    frontend: {
      general: { searchKey, searchPagePath: search_page_path } = {},
      fields: {
        autocomplete: autocompleteConfigs,
        page: { title: titleConfigs } = {},
        input: inputConfigs,
        voice: voiceConfigs,
      } = {},
      results: {
        filterDirection,
        showFilterResultsCount,
        sort: sortConfigs,
        empty: notFoundConfigs,
        page: {
          customCss: searchPageCustomCss,
          defaultResultsLayout,
          showLayoutOptions,
        } = {},
      } = {},
    } = {},

    backend: {
      redirects: { rules: redirectRules, suggest: useRedirectSuggestions } = {},
    } = {},
  } = search || {};

  useEffect(() => {
    setCustomParams(requestCustomParams || {});
  }, [requestCustomParams]);

  useEffect(() => {
    setResultsLayoutMode(defaultResultsLayout || "grid");
  }, [defaultResultsLayout]);

  useEffect(() => {
    document.addEventListener("beon.search.setup.customparams", (event) => {
      event.preventDefault();
      const details = event.detail || event.details || {};
      if (details.data) {
        setCustomParams(details.data);

        if (details.callback && typeof details.callback === "function") {
          details.callback();
        }
      }
    });
  }, []);

  return (
    <ConfigContext.Provider
      value={{
        api_key: id,
        customParams,
        resultsLayoutMode,
        setResultsLayoutMode,
        showLayoutOptions,
        setId,
        show_sandbox_input,
        sortOptions,
        tenant_id: id,

        searchKey,
        search_page_path,

        autocompleteConfigs,
        inputConfigs,
        notFoundConfigs,
        sortConfigs,
        titleConfigs,
        voiceConfigs,

        areFiltersAvailable,
        setAreFiltersAvailable,
        filterDirection,
        showFilterResultsCount,
        searchPageCustomCss,

        redirectRules,
        useRedirectSuggestions,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const {
    api_key,
    customParams,
    resultsLayoutMode,
    showLayoutOptions,
    setId,
    setResultsLayoutMode,
    show_sandbox_input,
    sortOptions,
    tenant_id,

    searchKey,
    search_page_path,

    autocompleteConfigs,
    inputConfigs,
    notFoundConfigs,
    sortConfigs,
    titleConfigs,
    voiceConfigs,

    areFiltersAvailable,
    setAreFiltersAvailable,
    filterDirection,
    searchPageCustomCss,
    showFilterResultsCount,

    redirectRules,
    useRedirectSuggestions,
  } = useContext(ConfigContext);

  return {
    customParams,
    api_key,
    resultsLayoutMode,
    setId,
    setResultsLayoutMode,
    showLayoutOptions,
    show_sandbox_input,
    sortOptions,
    tenant_id,

    searchKey,
    search_page_path,

    autocompleteConfigs,
    inputConfigs,
    notFoundConfigs,
    sortConfigs,
    titleConfigs,
    voiceConfigs,

    areFiltersAvailable,
    setAreFiltersAvailable,
    filterDirection,
    searchPageCustomCss,
    showFilterResultsCount,

    redirectRules,
    useRedirectSuggestions,
  };
};
